import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "reactstrap";

import { BASE_URL_IMG } from "../../assets/constants";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import useLogout from "../../hooks/useLogout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { getSmartInitials } from "../../utils/Utils";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { useLocation } from "react-router-dom";
import { pharmacyVendorSettlementReport } from "../../api/Transactions";
import { pharmacyAccountsReport } from "../../api/Transactions";

const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      server_search: "",
      page: 1,
      limit: 25,
    },
  });

  const { logout } = useLogout();
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  // summary state
  const [summary, setSummary] = useState({
    aggregatorDr: 0,
    orderAmount: 0,
    totalDue: 0,
    totalPaid: 0,
    totalRefunded: 0,
    vendorDr: 0,
  });

  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
  };
  const handlePageChange = (page) => {
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };

  const columns = [
      {
      name: "Order Number",
      selector: (row) => row?.orderNum || "N/A",
      sortable: true,
      cell: (row) => <span>{row?.orderNum || "N/A"}</span>,
    },
        {
      name: "Module Type",
      selector: (row) => row?.moduleType || "N/A",
      sortable: true,
      cell: (row) => <span>{row?.moduleType || "N/A"}</span>,
    },
    //   {
    //   name: "Pharmacy",
    //   selector: (row) => row?.pharmacyInfo || "-",
    //   sortable: true,
    //   cell: (row) => (
    //     <div
    //       style={{
    //         whiteSpace: "normal",
    //         wordBreak: "break-word",
    //         lineHeight: "1.4",
    //       }}
    //     >
    //       {row?.pharmacyInfo || "-"}
    //     </div>
    //   ),
    //   wrap: true,
    // },
    {
      name: "Vendor Dr",
      selector: (row) => row?.vendorDr,
      sortable: true,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {row?.vendorDr}
        </div>
      ),
      wrap: true,
    },
    // {
    //   name: "Status",
    //   selector: (row) => row?.status,
    //   sortable: true,
    //   cell: (row) => (
    //     <span
    //       className={`badge text-bg-${
    //         row?.status === "cod"
    //           ? "warning"
    //           : row?.status === "paid"
    //           ? "success"
    //           : "secondary"
    //       }`}
    //     >
    //       {row?.status}
    //     </span>
    //   ),
    // },
   {
      name: "Aggregator Dr",
      selector: (row) => row?.aggregatorDr,
      sortable: true,
    },
    {
      name: "Order Amount",
      selector: (row) => row?.orderAmount,
      sortable: true,
      cell: (row) => <span>₹{row?.orderAmount}</span>,
    },
        {
      name: "Payment Status",
      selector: (row) => row?.paymentStatus || "N/A",
      sortable: true,
      cell: (row) => <span>{row?.paymentStatus || "N/A"}</span>,
    },
    // {
    //   name: "Payout Status",
    //   selector: (row) => row?.payoutStatus,
    //   sortable: true,
    //   cell: (row) => (
    //     <span
    //       className={`badge text-bg-${
    //         row?.payoutStatus === "pending"
    //           ? "warning"
    //           : row?.payoutStatus === "paid"
    //           ? "success"
    //           : "secondary"
    //       }`}
    //     >
    //       {row?.payoutStatus}
    //     </span>
    //   ),
    // },
    {
      name: "Date and Time",
      selector: (row) => row?.date,
      sortable: true,
       cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.4",
          }}
        >
          {row?.date}
        </div>
      ),
    },
  ];

  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);

  const serverSideSearch = (data) => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
    };
    setLoading(true);
    pharmacyAccountsReport(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setLoading(false);
          const resData = res?.data?.data;

          setSummary(resData?.summary || {});
          setTotalRows(resData?.totalRecords ?? resData?.rows?.length ?? 0);
          setValue("limit", resData?.totalRecords ?? resData?.rows?.length ?? 0);
          setTableData(resData?.rows || []);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };

//   useEffect(() => {
//     if (watch("server_search")?.length == 0) {
//       serverSideSearch();
//     }
//   }, [watch("server_search")]);

  return (
    <>
      <Head title="Accounts Reports" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Account Report's 
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {/* Summary cards */}
        {/* <Block className="pt-0 mt-3">
          <div className="row g-3 mb-3">
            <SummaryCard label="Aggregator Dr" value={summary.aggregatorDr} />
            <SummaryCard label="Order Amount" value={summary.orderAmount} />
            <SummaryCard label="Total Due" value={summary.totalDue} />
            <SummaryCard label="Total Paid" value={summary.totalPaid} />
            <SummaryCard label="Total Refunded" value={summary.totalRefunded} />
            <SummaryCard label="Vendor Dr" value={summary.vendorDr} />
          </div>
        </Block> */}

        <Block className="pt-0">
          <ApiPaginationDataTable
            columns={columns}
            data={tableData}
            title={"Reports"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
        </Block>
      </Content>
    </>
  );
};

// small reusable summary card
const SummaryCard = ({ label, value }) => (
  <div className="col-md-2 col-sm-4 col-6">
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body p-3">
        <div className="text-muted small">{label}</div>
        <div className="fs-6 fw-bold">₹{value ?? 0}</div>
      </div>
    </div>
  </div>
);

export default User;